import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMagicWand: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMagicWand"><Path d="M9.93555 2.02246L10.4104 8.17056L5.15737 11.4002L10.297 12.642L2.68945 20.2495L3.75011 21.3102L11.3577 13.7027L12.5996 18.8424L15.8292 13.5893L21.9773 14.0642L17.9793 9.36937L20.3308 3.66891L14.6304 6.02038L9.93555 2.02246Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMagicWand;
